import React, {useEffect, useState} from "react";
import {
    Box, Button, Flex, HStack,
    Tag,
    Text,
    VStack,
} from '@chakra-ui/react';
import {format, parseISO} from 'date-fns';

import WebApp from "@twa-dev/sdk";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import { FaPlus } from "react-icons/fa";


function RemindersPage() {
    const [reminders, setReminders] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const { lang } = useParams();

    const {t} = useTranslation();


    const fetchReminders = async () => {
        setLoading(true);
        try {
            const initData = WebApp?.initData;

            const response = await fetch("/api/ai-notification/reminders", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Telegram-InitData": initData ?? "",
                }
            });

            if (!response.ok) throw new Error("Request failed");

            const data = await response.json();
            setReminders(data);
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };


    const deleteReminder = async (id: string) => {
        setLoading(true);
        try {
            const initData = WebApp?.initData;

            const response = await fetch("/api/ai-notification/reminders/" + id, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-Telegram-InitData": initData ?? "",
                }
            });

            if (!response.ok) throw new Error("Request failed");

            // @ts-ignore
            setReminders(reminders.filter(i => i.id !== id));
        } catch (error) {

        } finally {
            setLoading(false);
        }

    }

    const editReminder = (id: string) => {
        navigate(`/${lang}/reminders/${id}/edit`);
    }

    const createReminder = () => {
        navigate(`/${lang}/reminders/create`);
    }

    useEffect(() => {
        fetchReminders();
    }, []);


    // @ts-ignore
    return (
        <Box maxW="md" mx="auto" mt={6} p={4}>
            <Text fontSize="2xl" fontWeight="bold" mb={4}>
                {t('reminders.reminders')}
            </Text>

            <Flex justify="flex-end" mb={4}>
                <Button
                    colorPalette="teal"
                    size="sm"
                    onClick={createReminder}>
                    {/* @ts-ignore */}
                    <FaPlus/>
                    Create Reminder
                </Button>
            </Flex>


            <VStack gap={3} align="stretch">
                {reminders.map((reminder, idx) => (
                    <Flex
                        key={idx}
                        direction="column"
                        p={4}
                        mb={4}
                        borderRadius="xl"
                        bg="gray.50"
                        boxShadow="sm"
                        border="1px solid"
                        borderColor="gray.200"
                    >
                        <HStack justify="space-between" mb={2}>
                            <Tag.Root colorPalette="blue">
                                {/* @ts-ignore */}
                                <Tag.Label>{reminder.category}</Tag.Label>
                            </Tag.Root>

                            <Text fontSize="sm" color="gray.600">
                                {/* @ts-ignore */}
                                {format(parseISO(reminder.remindAt), "dd.MM.yyyy HH:mm")}
                            </Text>
                        </HStack>


                        <Text fontWeight="medium" fontSize="md" color="gray.800" mb={3}>
                            {/* @ts-ignore */}
                            {reminder.text}
                        </Text>

                        <HStack justify="flex-end" gap={2}>
                            {/* @ts-ignore */}
                            <Button onClick={() => editReminder(reminder.id)} size="sm" colorPalette="blue" variant="outline">
                                Edit
                            </Button>
                            {/* @ts-ignore */}
                            <Button onClick={() => deleteReminder(reminder.id)} size="sm" colorPalette="red" variant="outline">
                                Delete
                            </Button>
                        </HStack>
                    </Flex>
                ))}


            </VStack>
        </Box>
    );
};


export default RemindersPage;
